var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLatestMobile(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 340.168,
    height: 289.11,
    viewBox: "0 0 340.168 289.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    "data-name": "Intersection 2",
    d: "M-930.489,292.925c-50.944-55.231-58.464-121.668-30.277-185.975s106.241-71.812,183.249-59.836,109.21-22.6,133.336,80.814-18.938,165.319-18.938,165.319-27.031,34.709-93.873,34.628c-14.228-.017-27.952.892-41.233,1.8-13.156.9-25.883,1.8-38.229,1.8C-870.2,331.477-901.132,324.753-930.489,292.925Z",
    transform: "translate(977.008 -42.367)",
    fill: "#eda751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestMobile);
export default __webpack_public_path__ + "static/media/latestMobile.14fb3dcd2f2c6f1372a4b73f1e258ad3.svg";
export { ForwardRef as ReactComponent };